var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportsRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:none;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M355.9 128h52L345 67.2v51.3c0 5 5.1 9.5 10.9 9.5z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M355.9 168c-28.1 0-50.9-22.2-50.9-49.6V40.7l-216.6-.6c-5.5 0-10.4 4.7-10.4 10v411.8c0 5.2 5.3 10.2 10.9 10.2h339c5.7 0 9.1-5.2 9.1-10.2V168h-81.1zM320 247c11 0 20 9 20 20s-9 20-20 20H145c-11 0-20-9-20-20s9-20 20-20h175zm-176-80h116c11 0 20 9 20 20s-9 20-20 20H144c-11 0-20-9-20-20s9-20 20-20zm226 200H145c-11 0-20-9-20-20s9-20 20-20h225c11 0 20 9 20 20s-9 20-20 20z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.2 129.8L345.5 12C338.1 4.8 328 .7 317.6.7L88.4.1C60.6.1 38 22.5 38 50.1v411.8C38 489 61.3 512 88.9 512h339c27.1 0 49.1-22.5 49.1-50.2V153.7c0-9.3-3.5-17.8-9.8-23.9zM345 67.2l62.9 60.8h-52c-5.8 0-10.9-4.5-10.9-9.6V67.2zM427.9 472h-339c-5.6 0-10.9-4.9-10.9-10.2V50.1c0-5.3 4.9-10 10.4-10l216.6.6v77.7c0 27.3 22.8 49.6 50.9 49.6H437v293.8c0 5-3.4 10.2-9.1 10.2z",
    fill: "#BF1D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 267c0 11 9 20 20 20h175c11 0 20-9 20-20s-9-20-20-20H145c-11 0-20 9-20 20z",
    fill: "#BF1D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 207h116c11 0 20-9 20-20s-9-20-20-20H144c-11 0-20 9-20 20s9 20 20 20z",
    fill: "#BF1D2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370 327H145c-11 0-20 9-20 20s9 20 20 20h225c11 0 20-9 20-20s-9-20-20-20z",
    fill: "#BF1D2E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsRed);
export default __webpack_public_path__ + "static/media/Reports_Red.8687c08fb225148e31211aa532f9535d.svg";
export { ForwardRef as ReactComponent };